import { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import _ from 'lodash';
import dayjs from 'dayjs';
import Yup from '../../../utils/yup';
import utc from 'dayjs/plugin/utc';

import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import useUsers from '../../../context/UsersContext';
import resourceThreeService from '../../../service/resources/resourceThree.service';

import { DeleteDialogUI, FormButtonPanelUI, FormHeaderUI } from '../../Interface';
import { ResourceThreeFields } from './ResourceThreeFields';
import ResoureThreeTabs from './ResoureThreeTabs';
import { cleanValues, getJokerFieldType } from '../../../utils/helper';
import { getDynVals } from '../../../utils/DynHelper';
import { JokerFieldTypes } from '../../../config/joker';
import History from '../../History/History';
import HistoryDialog from '../../History/HistoryDialog';

export const ResourceThreePage = ({ resourceThreeState, dialog }) => {
  const {
    setRefetchTable,
    selectedValues,
    setSelectedValues,
    viewField,
    setViewField,
    operatorsDisabled,
    setOperatorsDisabled,
    submenu,
    canEdit,
    dynProps,
    setDynProps,
    dynLoading,
    setDynLoading,
    autocompleteData,
    jokerFields,
    jokerLoading,
    getJokerFields,
    propertyGroups,
  } = resourceThreeState;
  const { user } = useUsers();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [addField, setAddField] = useState(true);

  const [defaultValues, setDefaultValues] = useState({});
  const [initValues, setInitValues] = useState({});
  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});
  const [group, setGroup] = useState({
    id: [],
  });
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);

  useEffect(() => {
    getJokerFields();

    const def = {
      name: '',
      groupId: null,
      active: true,
      statusId: null,
      typeId: null,
      joker_char1: '',
      joker_char2: '',
      joker_char3: '',
      joker_char4: '',
      joker_char5: '',
      joker_char6: '',
      joker_char7: '',
      joker_char8: '',
      joker_char9: '',
      joker_char10: '',
      joker_date1: null,
      joker_date2: null,
      joker_date3: null,
      joker_date4: null,
      joker_date5: null,
      joker_num1: '',
      joker_num2: '',
      joker_num3: '',
      joker_num4: '',
      joker_num5: '',
      joker_int1: '',
      joker_int2: '',
      joker_int3: '',
      joker_int4: '',
      joker_int5: '',
    };

    setDefaultValues(def);
  }, []);

  useEffect(() => {
    if (Object.keys(autocompleteData).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          statusId: autocompleteData?.status?.defaultValue ?? null,
          typeId: autocompleteData?.type?.defaultValue ?? null,
          groupId: autocompleteData?.resourceGroup?.defaultValue ?? null,
        };
      });

      setDefaultSelectedValues((prev) => {
        return {
          ...prev,
          status: autocompleteData?.status?.defItem,
          type: autocompleteData?.type?.defItem,
          resourceGroup: autocompleteData?.resourceGroup?.defItem,
        };
      });
    }
  }, [autocompleteData]);

  useEffect(() => {
    setSelectedValues(defaultSelectedValues);
  }, [defaultSelectedValues]);

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!_.isEqual(defaultSelectedValues, selectedValues)) {
        valuesToForm();
        setOperatorsDisabled(false);
      } else {
        setOperatorsDisabled(true);
        setInitValues(defaultValues);
      }
    }
  }, [selectedValues]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    groupId: Yup.string().nullable(),
    active: Yup.boolean(),
    statusId: Yup.string().nullable(),
    typeId: Yup.string().nullable(),
    ...(jokerFields.length > 0
      ? Object.fromEntries(
          jokerFields.map((field) => {
            const fieldType = getJokerFieldType(field);
            return [
              field.field,
              fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
            ];
          })
        )
      : {}),
  });

  const valuesToForm = () => {
    const {
      name,
      groupId,
      active,
      statusId,
      typeId,
      joker_char1,
      joker_char2,
      joker_char3,
      joker_char4,
      joker_char5,
      joker_char6,
      joker_char7,
      joker_char8,
      joker_char9,
      joker_char10,
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1,
      joker_num2,
      joker_num3,
      joker_num4,
      joker_num5,
      joker_int1,
      joker_int2,
      joker_int3,
      joker_int4,
      joker_int5,
    } = selectedValues;

    setInitValues({
      name,
      groupId,
      active,
      statusId,
      dynamicFields: getDynVals(dynProps, selectedValues.dynamicProperties),
      typeId,
      joker_char1: joker_char1 ?? '',
      joker_char2: joker_char2 ?? '',
      joker_char3: joker_char3 ?? '',
      joker_char4: joker_char4 ?? '',
      joker_char5: joker_char5 ?? '',
      joker_char6: joker_char6 ?? '',
      joker_char7: joker_char7 ?? '',
      joker_char8: joker_char8 ?? '',
      joker_char9: joker_char9 ?? '',
      joker_char10: joker_char10 ?? '',
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1: joker_num1 ?? '',
      joker_num2: joker_num2 ?? '',
      joker_num3: joker_num3 ?? '',
      joker_num4: joker_num4 ?? '',
      joker_num5: joker_num5 ?? '',
      joker_int1: joker_int1 ?? '',
      joker_int2: joker_int2 ?? '',
      joker_int3: joker_int3 ?? '',
      joker_int4: joker_int4 ?? '',
      joker_int5: joker_int5 ?? '',
    });
  };

  const handleSubmit = (values, { resetForm }) => {
    if (!editButtonVisible) {
      updateObject(values);
    } else if (!addField) {
      handleInsertObject(values, resetForm);
    }
  };

  const updateObject = async (values) => {
    const updData = {
      ...cleanValues(values),
      updatedBy: user.userId,
    };

    resourceThreeService.updateResource(updData, selectedValues.id).then((data) => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });
      setRefetchTable(true);
      setEditButtonvisible(true);
      setViewField(true);
      setSelectedValues(data);

      if (dialog) {
        dialog.setTaskChanged(true);
        dialog.handleClose();
      }
    });
  };

  const handleInsertObject = async (values, resetForm) => {
    const insertObject = {
      ...cleanValues(values),
      createdBy: user.userId,
    };

    resourceThreeService
      .createResource(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });
        resetForm();
        setRefetchTable(true);
        setAddField(true);
        setViewField(true);
        setSelectedValues(data);

        if (dialog) {
          dialog.setTaskChanged(true);
          dialog.handleClose();
        }
      })
      .finally(() => {
        //@TODO loader
      });
  };

  dayjs.extend(utc);

  const handleRemoveElement = async () => {
    const deleteData = {
      deletedBy: user.userId,
    };
    resourceThreeService.deleteResource(deleteData, selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres törlés!',
        type: NotificationType.WARNING,
      });
      setRefetchTable(true);
      setShowDeleteDialog(false);
      setSelectedValues(defaultSelectedValues);

      if (dialog) {
        dialog.setTaskChanged(true);
        dialog.handleClose();
      }
    });
  };

  const handleTemplate = () => {
    resourceThreeService.getExcelTemplate().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleExport = () => {
    resourceThreeService.getExcelData().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleImport = (files) => {
    resourceThreeService.importExcel(files, user.userId).then(() => {
      setRefetchTable(true);
      addNotification({
        content: 'Az import sikeres!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const onAddClick = () => {
    setSelectedValues(defaultSelectedValues);
    setViewField(false);
    setAddField(false);
  };

  return (
    <>
      <div className="h-full overflow-auto custom-scrollbar">
        <div className="flex items-center flex-wrap justify-between">
          <FormHeaderUI
            addClick={!dialog ? onAddClick : null}
            addDisabled={!viewField || !canEdit}
            modClick={() => {
              setViewField(false);
              setEditButtonvisible(false);
            }}
            modDisabled={!viewField || operatorsDisabled || !canEdit}
            deleteClick={() => {
              setShowDeleteDialog(true);
            }}
            deleteDisabled={!viewField || operatorsDisabled || !canEdit}
            copyClick={() => {
              setViewField(false);
              setAddField(false);
            }}
            copyDisabled={!viewField || operatorsDisabled || !canEdit}
          />
          <div className="hidden sm:block">
            <History disabled={operatorsDisabled} onClick={() => setHistoryDialogOpen(!historyDialogOpen)} />
          </div>
        </div>
        <Formik
          initialValues={initValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          onSubmit={handleSubmit}
          enableReinitialize
          //validateOnMount={false}
        >
          {({ values, setFieldValue, errors, validateField, resetForm }) => (
            <Form>
              <ResourceThreeFields
                viewField={viewField}
                submenuId={submenu}
                selectedValues={selectedValues}
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
                validateField={validateField}
              />
              {!jokerLoading && (
                <ResoureThreeTabs
                  disabled={viewField}
                  submenuId={submenu}
                  setFieldValue={setFieldValue}
                  selectedValues={selectedValues}
                  setDefaultValues={setDefaultValues}
                  dynProperties={{ dynProps, setDynProps }}
                  user={user}
                  setRefetchTable={setRefetchTable}
                  propertyGroups={propertyGroups}
                  groupState={{ group, setGroup }}
                  dynLoadingState={{ dynLoading, setDynLoading }}
                  setSelectedValues={setSelectedValues}
                  handleImport={handleImport}
                  handleExport={handleExport}
                  handleTemplate={handleTemplate}
                  dialog={dialog}
                  addField={addField}
                />
              )}
              <FormButtonPanelUI
                onCancelClick={() => {
                  setViewField(true);
                  setEditButtonvisible(true);
                  setAddField(true);

                  resetForm();
                }}
                disabled={editButtonVisible && addField}
              />
            </Form>
          )}
        </Formik>
      </div>
      <HistoryDialog
        open={historyDialogOpen}
        handleClose={() => {
          setHistoryDialogOpen(false);
        }}
        formId={submenu}
        lineId={selectedValues.id}
        fieldConfig={[{ field: 'dynamicProperties', objKey: 'textVal' }]}
      />

      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />
    </>
  );
};
